import type { AdminIconProps } from "./UsersIcon";

/** Database-stack glyph — three discs viewed in profile. */
export function CacheIcon({ className, ...rest }: AdminIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={rest["aria-hidden"] ?? true}
    >
      <ellipse cx="12" cy="5" rx="8" ry="3" />
      <path d="M4 12c0 1.66 3.58 3 8 3s8-1.34 8-3" />
      <path d="M4 5v14c0 1.66 3.58 3 8 3s8-1.34 8-3V5" />
    </svg>
  );
}
